import styled from 'styled-components';
import TvSvg from '../../assets/amenities/tv.svg';

const TvIcon = styled(TvSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default TvIcon;
